export const catalogData =
// http://ly.bi3x.org/catalog/novye-tovary/?api=y
// 20201009163611
// http://ly.bi3x.org/catalog/novye-tovary/?api=y

    {
        "catalogSort": {
            "items": [{
                "active": false,
                "name": "А - Я",
                "sort": "name",
                "order": "asc",
                "request": "/catalog/test/?sort=name&order=asc"
            }, {
                "active": false,
                "name": "Я - A",
                "sort": "name",
                "order": "desc",
                "request": "/catalog/test/?sort=name&order=desc"
            }], "messages": {"placeholder": "Вкажіть тип сортування"}
        },
        "catalogSmartFilter": {
            "form": {"name": null, "action": "/catalog/test/", "method": "get"},
            "hidden": [{"name": "ajax", "value": "y"}],
            "ITEMS": {
                "183": {
                    "ID": "183",
                    "IBLOCK_ID": "24",
                    "CODE": "MINIMUM_PRICE",
                    "~NAME": "Минимальная цена",
                    "NAME": "Минимальная цена",
                    "PROPERTY_TYPE": "N",
                    "USER_TYPE": null,
                    "USER_TYPE_SETTINGS": null,
                    "DISPLAY_TYPE": "A",
                    "DISPLAY_EXPANDED": "Y",
                    "FILTER_HINT": "",
                    "VALUES": {
                        "MIN": {
                            "CONTROL_ID": "arCatalogFilter_183_MIN",
                            "CONTROL_NAME": "arCatalogFilter_183_MIN",
                            "VALUE": "52478"
                        },
                        "MAX": {
                            "CONTROL_ID": "arCatalogFilter_183_MAX",
                            "CONTROL_NAME": "arCatalogFilter_183_MAX",
                            "VALUE": "75252"
                        }
                    },
                    "DECIMALS": "2"
                },
                "184": {
                    "ID": "184",
                    "IBLOCK_ID": "24",
                    "CODE": "METALL",
                    "~NAME": "Металл",
                    "NAME": "Металл",
                    "PROPERTY_TYPE": "S",
                    "USER_TYPE": "directory",
                    "USER_TYPE_SETTINGS": {
                        "size": 1,
                        "width": 0,
                        "group": "N",
                        "multiple": "N",
                        "TABLE_NAME": "a_metals"
                    },
                    "DISPLAY_TYPE": "F",
                    "DISPLAY_EXPANDED": "N",
                    "FILTER_HINT": "",
                    "VALUES": {
                        "zoloto": {
                            "CONTROL_ID": "arCatalogFilter_184_2755422981",
                            "CONTROL_NAME": "arCatalogFilter_184_2755422981",
                            "CONTROL_NAME_ALT": "arCatalogFilter_184",
                            "HTML_VALUE_ALT": 2755422981,
                            "HTML_VALUE": "Y",
                            "VALUE": "zoloto",
                            "SORT": 0,
                            "UPPER": "ZOLOTO",
                            "FLAG": true,
                            "URL_ID": "zoloto",
                            "FACET_VALUE": "1",
                            "ELEMENT_COUNT": "10"
                        }
                    }
                },
                "186": {
                    "ID": "186",
                    "IBLOCK_ID": "24",
                    "CODE": "COLOR_METALL",
                    "~NAME": "Цвет металла",
                    "NAME": "Цвет металла",
                    "PROPERTY_TYPE": "S",
                    "USER_TYPE": "directory",
                    "USER_TYPE_SETTINGS": {
                        "size": 1,
                        "width": 0,
                        "group": "N",
                        "multiple": "N",
                        "TABLE_NAME": "a_colors"
                    },
                    "DISPLAY_TYPE": "F",
                    "DISPLAY_EXPANDED": "N",
                    "FILTER_HINT": "",
                    "VALUES": {
                        "biliy": {
                            "CONTROL_ID": "arCatalogFilter_186_3218423947",
                            "CONTROL_NAME": "arCatalogFilter_186_3218423947",
                            "CONTROL_NAME_ALT": "arCatalogFilter_186",
                            "HTML_VALUE_ALT": 3218423947,
                            "HTML_VALUE": "Y",
                            "VALUE": "biliy",
                            "SORT": 0,
                            "UPPER": "BILIY",
                            "FLAG": true,
                            "URL_ID": "biliy",
                            "FACET_VALUE": "2",
                            "ELEMENT_COUNT": "6"
                        },
                        "chervoniy": {
                            "CONTROL_ID": "arCatalogFilter_186_3589656623",
                            "CONTROL_NAME": "arCatalogFilter_186_3589656623",
                            "CONTROL_NAME_ALT": "arCatalogFilter_186",
                            "HTML_VALUE_ALT": 3589656623,
                            "HTML_VALUE": "Y",
                            "VALUE": "chervoniy",
                            "SORT": 0,
                            "UPPER": "CHERVONIY",
                            "FLAG": true,
                            "URL_ID": "chervoniy",
                            "FACET_VALUE": "11",
                            "ELEMENT_COUNT": "4"
                        }
                    }
                },
                "187": {
                    "ID": "187",
                    "IBLOCK_ID": "24",
                    "CODE": "PROBA",
                    "~NAME": "Проба",
                    "NAME": "Проба",
                    "PROPERTY_TYPE": "S",
                    "USER_TYPE": "directory",
                    "USER_TYPE_SETTINGS": {
                        "size": 1,
                        "width": 0,
                        "group": "N",
                        "multiple": "N",
                        "TABLE_NAME": "a_proba"
                    },
                    "DISPLAY_TYPE": "F",
                    "DISPLAY_EXPANDED": "N",
                    "FILTER_HINT": "",
                    "VALUES": {
                        "585": {
                            "CONTROL_ID": "arCatalogFilter_187_2630715057",
                            "CONTROL_NAME": "arCatalogFilter_187_2630715057",
                            "CONTROL_NAME_ALT": "arCatalogFilter_187",
                            "HTML_VALUE_ALT": 2630715057,
                            "HTML_VALUE": "Y",
                            "VALUE": "585",
                            "SORT": 100,
                            "UPPER": "585",
                            "FLAG": true,
                            "URL_ID": "585",
                            "FACET_VALUE": "3",
                            "ELEMENT_COUNT": "10"
                        }
                    }
                },
                "188": {
                    "ID": "188",
                    "IBLOCK_ID": "24",
                    "CODE": "VSTAVKI",
                    "~NAME": "Вставка",
                    "NAME": "Вставка",
                    "PROPERTY_TYPE": "S",
                    "USER_TYPE": "directory",
                    "USER_TYPE_SETTINGS": {
                        "size": 1,
                        "width": 0,
                        "group": "N",
                        "multiple": "N",
                        "TABLE_NAME": "a_vstavki"
                    },
                    "DISPLAY_TYPE": "F",
                    "DISPLAY_EXPANDED": "N",
                    "FILTER_HINT": "",
                    "VALUES": {
                        "diamant": {
                            "CONTROL_ID": "arCatalogFilter_188_1165216290",
                            "CONTROL_NAME": "arCatalogFilter_188_1165216290",
                            "CONTROL_NAME_ALT": "arCatalogFilter_188",
                            "HTML_VALUE_ALT": 1165216290,
                            "HTML_VALUE": "Y",
                            "VALUE": "diamant",
                            "SORT": 0,
                            "UPPER": "DIAMANT",
                            "FLAG": true,
                            "URL_ID": "diamant",
                            "FACET_VALUE": "4",
                            "ELEMENT_COUNT": "7"
                        },
                        "perli_kultivovani": {
                            "CONTROL_ID": "arCatalogFilter_188_3230038819",
                            "CONTROL_NAME": "arCatalogFilter_188_3230038819",
                            "CONTROL_NAME_ALT": "arCatalogFilter_188",
                            "HTML_VALUE_ALT": 3230038819,
                            "HTML_VALUE": "Y",
                            "VALUE": "perli_kultivovani",
                            "SORT": 0,
                            "UPPER": "PERLI_KULTIVOVANI",
                            "FLAG": true,
                            "URL_ID": "perli_kultivovani",
                            "FACET_VALUE": "37",
                            "ELEMENT_COUNT": "1"
                        },
                        "topaz": {
                            "CONTROL_ID": "arCatalogFilter_188_838008019",
                            "CONTROL_NAME": "arCatalogFilter_188_838008019",
                            "CONTROL_NAME_ALT": "arCatalogFilter_188",
                            "HTML_VALUE_ALT": 838008019,
                            "HTML_VALUE": "Y",
                            "VALUE": "topaz",
                            "SORT": 0,
                            "UPPER": "TOPAZ",
                            "FLAG": true,
                            "URL_ID": "topaz",
                            "FACET_VALUE": "17",
                            "ELEMENT_COUNT": "1"
                        },
                        "bez_vstavki": {
                            "CONTROL_ID": "arCatalogFilter_188_3534211685",
                            "CONTROL_NAME": "arCatalogFilter_188_3534211685",
                            "CONTROL_NAME_ALT": "arCatalogFilter_188",
                            "HTML_VALUE_ALT": 3534211685,
                            "HTML_VALUE": "Y",
                            "VALUE": "bez_vstavki",
                            "SORT": 1,
                            "UPPER": "BEZ_VSTAVKI",
                            "FLAG": true,
                            "URL_ID": "bez_vstavki",
                            "FACET_VALUE": "19",
                            "ELEMENT_COUNT": "1"
                        }
                    }
                },
                "191": {
                    "ID": "191",
                    "IBLOCK_ID": "24",
                    "CODE": "ST_VSTAVKA_COLOR",
                    "~NAME": "Цвет вставки",
                    "NAME": "Цвет вставки",
                    "PROPERTY_TYPE": "S",
                    "USER_TYPE": "directory",
                    "USER_TYPE_SETTINGS": {
                        "size": 1,
                        "width": 0,
                        "group": "N",
                        "multiple": "N",
                        "TABLE_NAME": "a_colors"
                    },
                    "DISPLAY_TYPE": "F",
                    "DISPLAY_EXPANDED": "N",
                    "FILTER_HINT": "",
                    "VALUES": {
                        "bezbarvniy": {
                            "CONTROL_ID": "arCatalogFilter_191_3499411208",
                            "CONTROL_NAME": "arCatalogFilter_191_3499411208",
                            "CONTROL_NAME_ALT": "arCatalogFilter_191",
                            "HTML_VALUE_ALT": 3499411208,
                            "HTML_VALUE": "Y",
                            "VALUE": "bezbarvniy",
                            "SORT": 0,
                            "UPPER": "BEZBARVNIY",
                            "FLAG": true,
                            "URL_ID": "bezbarvniy",
                            "FACET_VALUE": "5",
                            "ELEMENT_COUNT": "6"
                        },
                        "biliy": {
                            "CONTROL_ID": "arCatalogFilter_191_3218423947",
                            "CONTROL_NAME": "arCatalogFilter_191_3218423947",
                            "CONTROL_NAME_ALT": "arCatalogFilter_191",
                            "HTML_VALUE_ALT": 3218423947,
                            "HTML_VALUE": "Y",
                            "VALUE": "biliy",
                            "SORT": 0,
                            "UPPER": "BILIY",
                            "FLAG": true,
                            "URL_ID": "biliy",
                            "FACET_VALUE": "2",
                            "ELEMENT_COUNT": "1"
                        },
                        "chorniy": {
                            "CONTROL_ID": "arCatalogFilter_191_3329127398",
                            "CONTROL_NAME": "arCatalogFilter_191_3329127398",
                            "CONTROL_NAME_ALT": "arCatalogFilter_191",
                            "HTML_VALUE_ALT": 3329127398,
                            "HTML_VALUE": "Y",
                            "VALUE": "chorniy",
                            "SORT": 0,
                            "UPPER": "CHORNIY",
                            "FLAG": true,
                            "URL_ID": "chorniy",
                            "FACET_VALUE": "12",
                            "ELEMENT_COUNT": "1"
                        },
                        "london_blyu_topaz": {
                            "CONTROL_ID": "arCatalogFilter_191_3374416450",
                            "CONTROL_NAME": "arCatalogFilter_191_3374416450",
                            "CONTROL_NAME_ALT": "arCatalogFilter_191",
                            "HTML_VALUE_ALT": 3374416450,
                            "HTML_VALUE": "Y",
                            "VALUE": "london_blyu_topaz",
                            "SORT": 0,
                            "UPPER": "LONDON_BLYU_TOPAZ",
                            "FLAG": true,
                            "URL_ID": "london_blyu_topaz",
                            "FACET_VALUE": "27",
                            "ELEMENT_COUNT": "1"
                        }
                    }
                },
                "192": {
                    "ID": "192",
                    "IBLOCK_ID": "24",
                    "CODE": "COLLECTION",
                    "~NAME": "Коллекция",
                    "NAME": "Коллекция",
                    "PROPERTY_TYPE": "E",
                    "USER_TYPE": null,
                    "USER_TYPE_SETTINGS": null,
                    "DISPLAY_TYPE": "F",
                    "DISPLAY_EXPANDED": "N",
                    "FILTER_HINT": "",
                    "VALUES": {
                        "50714": {
                            "CONTROL_ID": "arCatalogFilter_192_2567256152",
                            "CONTROL_NAME": "arCatalogFilter_192_2567256152",
                            "CONTROL_NAME_ALT": "arCatalogFilter_192",
                            "HTML_VALUE_ALT": 2567256152,
                            "HTML_VALUE": "Y",
                            "VALUE": "Без коллекции",
                            "SORT": 500,
                            "UPPER": "БЕЗ КОЛЛЕКЦИИ",
                            "FLAG": true,
                            "URL_ID": "bez-kollektsii",
                            "FACET_VALUE": "50714",
                            "ELEMENT_COUNT": "9"
                        },
                        "52994": {
                            "CONTROL_ID": "arCatalogFilter_192_4048246737",
                            "CONTROL_NAME": "arCatalogFilter_192_4048246737",
                            "CONTROL_NAME_ALT": "arCatalogFilter_192",
                            "HTML_VALUE_ALT": 4048246737,
                            "HTML_VALUE": "Y",
                            "VALUE": "Eclipse",
                            "SORT": 500,
                            "UPPER": "ECLIPSE",
                            "FLAG": true,
                            "URL_ID": "eclipse",
                            "FACET_VALUE": "52994",
                            "ELEMENT_COUNT": "1"
                        }
                    }
                },
                "193": {
                    "ID": "193",
                    "IBLOCK_ID": "24",
                    "CODE": "VID",
                    "~NAME": "Тип изделия",
                    "NAME": "Тип изделия",
                    "PROPERTY_TYPE": "S",
                    "USER_TYPE": "directory",
                    "USER_TYPE_SETTINGS": {
                        "size": 1,
                        "width": 0,
                        "group": "N",
                        "multiple": "N",
                        "TABLE_NAME": "a_types"
                    },
                    "DISPLAY_TYPE": "F",
                    "DISPLAY_EXPANDED": "Y",
                    "FILTER_HINT": "",
                    "VALUES": {
                        "braslet": {
                            "CONTROL_ID": "arCatalogFilter_193_341337972",
                            "CONTROL_NAME": "arCatalogFilter_193_341337972",
                            "CONTROL_NAME_ALT": "arCatalogFilter_193",
                            "HTML_VALUE_ALT": 341337972,
                            "HTML_VALUE": "Y",
                            "VALUE": "braslet",
                            "SORT": 0,
                            "UPPER": "BRASLET",
                            "FLAG": true,
                            "URL_ID": "braslet",
                            "FACET_VALUE": "16",
                            "ELEMENT_COUNT": "1"
                        },
                        "lantsyuzhok": {
                            "CONTROL_ID": "arCatalogFilter_193_151778265",
                            "CONTROL_NAME": "arCatalogFilter_193_151778265",
                            "CONTROL_NAME_ALT": "arCatalogFilter_193",
                            "HTML_VALUE_ALT": 151778265,
                            "HTML_VALUE": "Y",
                            "VALUE": "lantsyuzhok",
                            "SORT": 0,
                            "UPPER": "LANTSYUZHOK",
                            "FLAG": true,
                            "URL_ID": "lantsyuzhok",
                            "FACET_VALUE": "20",
                            "ELEMENT_COUNT": "1"
                        },
                        "persten": {
                            "CONTROL_ID": "arCatalogFilter_193_853360208",
                            "CONTROL_NAME": "arCatalogFilter_193_853360208",
                            "CONTROL_NAME_ALT": "arCatalogFilter_193",
                            "HTML_VALUE_ALT": 853360208,
                            "HTML_VALUE": "Y",
                            "VALUE": "persten",
                            "SORT": 0,
                            "UPPER": "PERSTEN",
                            "FLAG": true,
                            "URL_ID": "persten",
                            "FACET_VALUE": "6",
                            "ELEMENT_COUNT": "2"
                        },
                        "serezhki": {
                            "CONTROL_ID": "arCatalogFilter_193_2037043039",
                            "CONTROL_NAME": "arCatalogFilter_193_2037043039",
                            "CONTROL_NAME_ALT": "arCatalogFilter_193",
                            "HTML_VALUE_ALT": 2037043039,
                            "HTML_VALUE": "Y",
                            "VALUE": "serezhki",
                            "SORT": 0,
                            "UPPER": "SEREZHKI",
                            "FLAG": true,
                            "URL_ID": "serezhki",
                            "FACET_VALUE": "10",
                            "ELEMENT_COUNT": "6"
                        }
                    }
                },
                "214": {
                    "ID": "214",
                    "IBLOCK_ID": "24",
                    "CODE": "VID_IZDELIYA",
                    "~NAME": "Вид",
                    "NAME": "Вид",
                    "PROPERTY_TYPE": "L",
                    "USER_TYPE": null,
                    "USER_TYPE_SETTINGS": null,
                    "DISPLAY_TYPE": "F",
                    "DISPLAY_EXPANDED": "N",
                    "FILTER_HINT": "",
                    "VALUES": []
                },
                "215": {
                    "ID": "215",
                    "IBLOCK_ID": "24",
                    "CODE": "Type_vstavok",
                    "~NAME": "Тип вставки",
                    "NAME": "Тип вставки",
                    "PROPERTY_TYPE": "L",
                    "USER_TYPE": null,
                    "USER_TYPE_SETTINGS": null,
                    "DISPLAY_TYPE": "F",
                    "DISPLAY_EXPANDED": "N",
                    "FILTER_HINT": "",
                    "VALUES": []
                },
                "Розничная": {
                    "ID": "4",
                    "CODE": "Розничная",
                    "~NAME": "Розничная",
                    "NAME": "Розничная",
                    "PRICE": true,
                    "VALUES": {
                        "MIN": {
                            "CONTROL_ID": "arCatalogFilter_P4_MIN",
                            "CONTROL_NAME": "arCatalogFilter_P4_MIN",
                            "VALUE": "0",
                            "CURRENCY": "UAH"
                        },
                        "MAX": {
                            "CONTROL_ID": "arCatalogFilter_P4_MAX",
                            "CONTROL_NAME": "arCatalogFilter_P4_MAX",
                            "VALUE": "75252",
                            "CURRENCY": "UAH"
                        }
                    },
                    "ENCODED_ID": "a87ff679a2f3e71d9181a67b7542122c",
                    "CURRENCIES": {"UAH": "Гривня"},
                    "DECIMALS": "2"
                }
            },
            "actions": {"resetFilter": {"href": "/catalog/test/filter/clear/apply/", "text": "Сбросить фильтр"}}
        },
        "catalogSectionList": {
            "items": [
                {
                "id": 52612,
                "name": "Браслет з білого золота з діамантами: 421650120201",
                "detailPage": "/catalog/test/braslet-iz-belogo-zolota-s-brilliantami-artikul-421650120201/",
                "detailText": {
                    "TYPE": "HTML",
                    "TEXT": "Надеть Серьги из белого золота Dress code с бриллиантами. Артикул: 219102820201 - это как выиграть лотерею, при чем дважды. Синий бриллиант сулит яркую жизнь, уверенность в себе и обилие жизненных сил. В то время как черный обладает решительностью, активностью и выдержкой. Обещаем, что будете выходить победительницей из сложных ситуаций хотя бы потому, что с коллекцией Dress code легко выбрать украшение на все случаи жизни. Переливами разноцветных камней мы создаем обворожительную атмосферу вокруг наших изделий и их владелиц."
                },
                "article": 52612,
                "price": {"price": 0, "printPrice": "0 грн."},
                "offer": {"id": 57663, "price": {"price": 0, "printPrice": "0 грн."}, "current": true},
                "offers": [{"id": 57663, "price": {"price": 0, "printPrice": "0 грн."}, "current": true}, {
                    "id": 57066,
                    "price": {"price": 0, "printPrice": "0 грн."},
                    "current": false
                }, {"id": 57065, "price": {"price": 0, "printPrice": "0 грн."}, "current": false}, {
                    "id": 57064,
                    "price": {"price": 0, "printPrice": "0 грн."},
                    "current": false
                }, {"id": 57063, "price": {"price": 71918, "printPrice": "71918 грн."}, "current": false}],
                "propsForCheck": [],
                "attributes": {"id": "bx_3966226736_52612"},
                "pictures": [{
                    "alt": "Браслет з білого золота з діамантами: 421650120201",
                    "src": "/upload/resize_cache/iblock/815/200_200_140cd750bba9870f18aada2478b24840a/815c98274d95fd3c2ddaa9446baad3b8.jpg"
                }],
                "buyPath": "/ajax/?id=57663&action=addToBasket"
            },
                {
                "id": 52034,
                "name": "Сережки з червоного золота с перлами. Артикул: 219168210101",
                "detailPage": "/catalog/test/sergi-iz-krasnogo-zolota-s-zhemchugom-artikul-219168210101/",
                "article": 52034,
                "price": {"price": 54151.45, "printPrice": "54151.45 грн."},
                "offer": {"id": 57086, "price": {"price": 54151.45, "printPrice": "54151.45 грн."}, "current": true},
                "offers": [{"id": 57086, "price": {"price": 54151.45, "printPrice": "54151.45 грн."}, "current": true}],
                "propsForCheck": [],
                "attributes": {"id": "bx_3966226736_52034"},
                "pictures": [{
                    "alt": "Сережки з червоного золота с перлами. Артикул: 219168210101",
                    "src": "/upload/resize_cache/iblock/2f1/200_200_140cd750bba9870f18aada2478b24840a/2f139e57a1c6eb00f9d0b1e68900a36e.jpg"
                }],
                "buyPath": "/ajax/?id=57086&action=addToBasket"
            },
                {
                "id": 52026,
                "name": "Сережки з білого золота. Артикул: 219157820201",
                "detailPage": "/catalog/test/sergi-iz-belogo-zolota-artikul-219157820201/",
                "detailText": {
                    "TYPE": "HTML",
                    "TEXT": "Это классическое украшение Dress code создано, чтобы облегчить вам жизнь. Теперь не нужно каждое утро в замешательстве минут пять осматривать шкатулку с драгоценностями, а следующие десять их в спешке примерять. Мы нашли альтернативу. Достаточно одного бриллианта чтобы сделать ваш дневной или вечерний образ целостным и завершенным. Достаточно одного аккуратного Кольца из белого золота Dress code с бриллиантами. Артикул: 119103120201 и вы кокетливо обратите внимание на ваши нежные руки и утонченный вкус."
                },
                "article": 52026,
                "price": {"price": 63866, "printPrice": "63866 грн."},
                "offer": {"id": 56892, "price": {"price": 63866, "printPrice": "63866 грн."}, "current": true},
                "offers": [{"id": 56892, "price": {"price": 63866, "printPrice": "63866 грн."}, "current": true}],
                "propsForCheck": [],
                "attributes": {"id": "bx_3966226736_52026"},
                "pictures": [{
                    "alt": "Сережки з білого золота. Артикул: 219157820201",
                    "src": "/upload/resize_cache/iblock/cfd/200_200_140cd750bba9870f18aada2478b24840a/cfdf1c9c0ecd88ba44ac70c4488a1108.jpg"
                }],
                "buyPath": "/ajax/?id=56892&action=addToBasket"
            },
                {
                "id": 52009,
                "name": "Сережки з червоного золота з діамантами. Артикул: 219144820101 ",
                "detailPage": "/catalog/test/sergi-iz-krasnogo-zolota-s-brilliantami-artikul-219144820101/",
                "detailText": {
                    "TYPE": "HTML",
                    "TEXT": "Надеть Серьги из белого золота Dress code с бриллиантами. Артикул: 219102820201 - это как выиграть лотерею, при чем дважды. Синий бриллиант сулит яркую жизнь, уверенность в себе и обилие жизненных сил. В то время как черный обладает решительностью, активностью и выдержкой. Обещаем, что будете выходить победительницей из сложных ситуаций хотя бы потому, что с коллекцией Dress code легко выбрать украшение на все случаи жизни. Переливами разноцветных камней мы создаем обворожительную атмосферу вокруг наших изделий и их владелиц."
                },
                "article": 52009,
                "price": {"price": 75252, "printPrice": "75252 грн."},
                "offer": {"id": 56444, "price": {"price": 75252, "printPrice": "75252 грн."}, "current": true},
                "offers": [{"id": 56444, "price": {"price": 75252, "printPrice": "75252 грн."}, "current": true}],
                "propsForCheck": [],
                "attributes": {"id": "bx_3966226736_52009"},
                "pictures": [{
                    "alt": "Сережки з червоного золота з діамантами. Артикул: 219144820101 ",
                    "src": "/upload/resize_cache/iblock/90f/200_200_140cd750bba9870f18aada2478b24840a/90fa5e8cf8c4b83bb41aa0f1db92e96b.jpg"
                }],
                "buyPath": "/ajax/?id=56444&action=addToBasket"
            },
                {
                "id": 51917,
                "name": "Сережки з білого золота з сапфіром та топазом Eclipse. Артикул: 219109020201",
                "detailPage": "/catalog/test/sergi-iz-belogo-zolota-s-sapfirom-i-topazom-eclipse-artikul-219109020201/",
                "detailText": {
                    "TYPE": "HTML",
                    "TEXT": "Надеть Серьги из белого золота Dress code с бриллиантами. Артикул: 219102820201 - это как выиграть лотерею, при чем дважды. Синий бриллиант сулит яркую жизнь, уверенность в себе и обилие жизненных сил. В то время как черный обладает решительностью, активностью и выдержкой. Обещаем, что будете выходить победительницей из сложных ситуаций хотя бы потому, что с коллекцией Dress code легко выбрать украшение на все случаи жизни. Переливами разноцветных камней мы создаем обворожительную атмосферу вокруг наших изделий и их владелиц."
                },
                "article": 51917,
                "price": {"price": 68212, "printPrice": "68212 грн."},
                "offer": {"id": 53075, "price": {"price": 68212, "printPrice": "68212 грн."}, "current": true},
                "offers": [{"id": 53075, "price": {"price": 68212, "printPrice": "68212 грн."}, "current": true}],
                "propsForCheck": [],
                "attributes": {"id": "bx_3966226736_51917"},
                "pictures": [{
                    "alt": "Сережки з білого золота з сапфіром та топазом Eclipse. Артикул: 219109020201",
                    "src": "/upload/resize_cache/iblock/123/200_200_140cd750bba9870f18aada2478b24840a/123d0168f45dc79d464b78ee8e4af53d.jpg"
                }],
                "buyPath": "/ajax/?id=53075&action=addToBasket"
            },
                {
                "id": 51864,
                "name": "Сережки з червоного золота. Артикул: 210578520101",
                "detailPage": "/catalog/test/210578520101/",
                "article": 51864,
                "price": {"price": 63444, "printPrice": "63444 грн."},
                "offer": {"id": 56459, "price": {"price": 63444, "printPrice": "63444 грн."}, "current": true},
                "offers": [{"id": 56459, "price": {"price": 63444, "printPrice": "63444 грн."}, "current": true}],
                "propsForCheck": [],
                "attributes": {"id": "bx_3966226736_51864"},
                "pictures": [{
                    "alt": "Сережки з червоного золота. Артикул: 210578520101",
                    "src": "/upload/resize_cache/iblock/2bb/200_200_140cd750bba9870f18aada2478b24840a/2bb5d09cfe86f57cdace4bd3be558cba.jpg"
                }],
                "buyPath": "/ajax/?id=56459&action=addToBasket"
            },
                {
                "id": 51828,
                "name": "Сережки з білого золота з діамантами. Артикул:210515420201",
                "detailPage": "/catalog/test/sergi-iz-belogo-zolota-s-brilliantami-artikul-210515420201/",
                "detailText": {
                    "TYPE": "HTML",
                    "TEXT": "Надеть Серьги из белого золота Dress code с бриллиантами. Артикул: 219102820201 - это как выиграть лотерею, при чем дважды. Синий бриллиант сулит яркую жизнь, уверенность в себе и обилие жизненных сил. В то время как черный обладает решительностью, активностью и выдержкой. Обещаем, что будете выходить победительницей из сложных ситуаций хотя бы потому, что с коллекцией Dress code легко выбрать украшение на все случаи жизни. Переливами разноцветных камней мы создаем обворожительную атмосферу вокруг наших изделий и их владелиц."
                },
                "article": 51828,
                "price": {"price": 71287, "printPrice": "71287 грн."},
                "offer": {"id": 55856, "price": {"price": 71287, "printPrice": "71287 грн."}, "current": true},
                "offers": [{"id": 55856, "price": {"price": 71287, "printPrice": "71287 грн."}, "current": true}],
                "propsForCheck": [],
                "attributes": {"id": "bx_3966226736_51828"},
                "pictures": [{
                    "alt": "Сережки з білого золота з діамантами. Артикул:210515420201",
                    "src": "/upload/resize_cache/iblock/090/200_200_140cd750bba9870f18aada2478b24840a/0904cb6066c64405952fc6f5be81b6eb.jpg"
                }],
                "buyPath": "/ajax/?id=55856&action=addToBasket"
            },
                {
                "id": 51277,
                "name": "Кольцо из білого золота з діамантами. Артикул: 119157820201",
                "detailPage": "/catalog/test/119157820201/",
                "detailText": {
                    "TYPE": "HTML",
                    "TEXT": "Это классическое украшение Dress code создано, чтобы облегчить вам жизнь. Теперь не нужно каждое утро в замешательстве минут пять осматривать шкатулку с драгоценностями, а следующие десять их в спешке примерять. Мы нашли альтернативу. Достаточно одного бриллианта чтобы сделать ваш дневной или вечерний образ целостным и завершенным. Достаточно одного аккуратного Кольца из белого золота Dress code с бриллиантами. Артикул: 119103120201 и вы кокетливо обратите внимание на ваши нежные руки и утонченный вкус."
                },
                "article": 51277,
                "price": {"price": 52478, "printPrice": "52478 грн."},
                "offer": {"id": 56891, "price": {"price": 52478, "printPrice": "52478 грн."}, "current": true},
                "offers": [{
                    "id": 56891,
                    "price": {"price": 52478, "printPrice": "52478 грн."},
                    "current": true
                }, {"id": 56890, "price": {"price": 0, "printPrice": "0 грн."}, "current": false}],
                "propsForCheck": [],
                "attributes": {"id": "bx_3966226736_51277"},
                "pictures": [{
                    "alt": "Кольцо из білого золота з діамантами. Артикул: 119157820201",
                    "src": "/upload/resize_cache/iblock/5fb/200_200_140cd750bba9870f18aada2478b24840a/5fb52e55ce7bc504cd1378c0d9ec48ae.jpg"
                }],
                "buyPath": "/ajax/?id=56891&action=addToBasket"
            }
            ],
            "pagination": {"pagingKey": "PAGEN_1", "pageCount": 2, "pageNumber": 1, "pageSize": 8},
            "apiPaths": {
                "like": {
                    "add": {
                        "method": "post",
                        "path": "/ajax/",
                        "params-example-data": {"id": 123, "action": "addLike"}
                    },
                    "remove": {
                        "method": "post",
                        "path": "/ajax/",
                        "params-example-data": {"id": 123, "action": "removeLike"}
                    }
                },
                "compare": {
                    "add": {
                        "method": "post",
                        "path": "/ajax/",
                        "params-example-data": {"id": 123, "action": "addCompare"}
                    },
                    "remove": {
                        "method": "post",
                        "path": "/ajax/",
                        "params-example-data": {"id": 123, "action": "removeCompare"}
                    }
                }
            },
            "messages": {
                "detail": "Детальнее (ua)",
                'title': 'Товари, що беруть участь в акції'
            }
        }
    }